var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarninginline = function SvgWarninginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.829 12.087 9.185 3.698A1.337 1.337 0 0 0 8 3c-.5 0-.942.261-1.185.698l-4.643 8.389c-.235.424-.229.927.018 1.345.246.417.682.666 1.166.666h9.288c.484 0 .92-.249 1.167-.666.245-.418.252-.92.018-1.345ZM7.55 6.75a.45.45 0 1 1 .9 0v3a.45.45 0 1 1-.9 0v-3ZM8 12.299a.6.6 0 1 1 0-1.2.6.6 0 0 1 0 1.2Z",
    fill: "#FB4A4A"
  })));
};
export default SvgWarninginline;